import { z } from "zod";

export const invocaPhoneResponseSchema = z.object({
  data: z.object({
    phone: z.object({
      promo_number: z.string(),
      promo_number_formatted: z.string(),
    }),
  }),
});

export type InvocaPhoneResponse = z.infer<typeof invocaPhoneResponseSchema>;
